<div class="w-full flex flex-col items-center show-web">
    <div class="flex items-center justify-center gap-[23px] w-full px-2">
        @for (info of cardInfo; track $index) {
        <div class="w-[400px]">
            <app-numbered-card [info]="info"></app-numbered-card>
        </div>
        }
    </div>
</div>

<div class="w-[350px] flex items-center px-2 show-mobile" [class.slide-in]="showPosts()">
    <app-numbered-card [info]="activeInfo"></app-numbered-card>
</div>
